export default "__VITE_ASSET__CREXGzAN__"